import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface PartySyncItem {
  id?: string;
  name: string;
  isClient: boolean;
  role?: 'claimant' | 'defendant' | 'other';
  type?: 'person' | 'organisation' | null;
}

export const useSyncMatterParties = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (parties: PartySyncItem[]) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PUT, data: { parties } });
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/parties`, fetchConfig);
      if (!response.ok) throw new Error('Failed to sync parties');
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.MatterParties, { matterId }]);
      },
    },
  );
};
